export default {"src":"/_next/static/image/public/images/ic_records_white_vertical_menu.a3ad23b1179ff14538ee6f8a0283d05d.svg","height":20,"width":20};